import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { restoreAffiliate } from 'scenes/Affiliates/sources/affiliates';

import { restore } from '../queryKeyFactory';

export const useRestoreAffiliate = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const restoreMutation = useMutation(restore(), restoreAffiliate, {
    successMessage: () => `Affiliate activated`,
    errorMessage: (e) => e.message,
  });

  const handleAction = ({ id, name }) => {
    return showModal({
      title: 'Activate Affiliate?',
      confirmActionLabel: 'Activate',
      bodyText: `«${name}»`,
    }).then(() => restoreMutation.mutateAsync({ id }));
  };

  return [handleAction, restoreMutation];
};
